<script lang="ts">
	import { run } from 'svelte/legacy';

	import { DataHandlerDeviceAdmin, Device } from "luxedo-data"
	import LoadingSpinner from "../../reusable/loaders/LoadingSpinner.svelte"
	import { TestStation } from "./TestStationController"

	let loadedDevice : Device | undefined = $state()
	let loadingText = $state("Preparing device...")
	let ongoing = $state()

	let initialDiskSpace = 0
	let diskSpace = 0

	let eidosListener : string

	TestStation.subscribe((ctx) => {
		loadedDevice = ctx.activeDevice
		ongoing = ctx.processingNewDevice
	})

	async function beginMonitoringDevice() {
		if (eidosListener) return

		DataHandlerDeviceAdmin.pull([4])
		let templateDevice = DataHandlerDeviceAdmin.get(4)
		loadingText = "Configuring new device..."
		eidosListener = templateDevice.addUpdateListener(onTemplateEidosReceived)
	}

	function onTemplateEidosReceived(templateDevice : Device) {
		let eidos = templateDevice.eidos
		if (!eidos || !eidos.cache || !!loadedDevice) return

		let space = eidos.cache.free_space_mb
		if (!initialDiskSpace) initialDiskSpace = space

		diskSpace = space

		if (diskSpace > initialDiskSpace) {
			const diskSpaceGB = diskSpace / 1000
			loadingText = `Allocating disk space - ${diskSpaceGB.toFixed(2)} GB`
		}
	}

	function reset() {
		console.warn("Resetting...")
		loadingText = "Configuring new device..."
		initialDiskSpace = 0
		diskSpace = 0

		if (eidosListener) {
			let templateDevice = DataHandlerDeviceAdmin.get(4)
			templateDevice.removeUpdateListener(eidosListener)
			eidosListener = undefined
		}
		return
	}
	
	run(() => {
		loadedDevice && reset()
	});
	run(() => {
		!ongoing && reset()
	});
	run(() => {
		ongoing && beginMonitoringDevice()
	});
</script>

<LoadingSpinner {loadingText} />

<style>
</style>